import React from 'react';
import { Part } from './styles';

interface Props {
  children: string;
  inputValue: string;
}

export const MarkedLabel: React.FC<Props> = ({ children, inputValue }) => {
  if (!inputValue) {
    return <>{children}</>;
  }

  const pattern = new RegExp(`(${inputValue})`, 'ig');
  const parts = children.split(pattern).map((part) => (
    <Part key={part} highlight={!!part.match(pattern)}>
      {part}
    </Part>
  ));
  return <>{parts}</>;
};
